 
import React, { useState, useEffect } from 'react';
import Slider from "react-slick"; 
import { Grid, Paper } from "@mui/material";

import {
  Col,Row
} from "reactstrap";
import CountryFlag from 'views/Hoc/countryFlag/countryFlag';
var _ = require('lodash');
 
const HomeEventMeetingSlider = ({ connections, sliderTitle=null, buyerPage}) => {
  let count = 0;
  const [slide, setSlide] = useState(0);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    afterChange: current => setSlide(current)
  };

  console.log('channels ',connections)

  return (

         <div className="ProductContainer" style={{ backgroundColor:buyerPage === true ? "#fff" : sliderTitle==="Latest Vendors"? "#f7f7f7" : "none", padding:"1px" }} id='dashslide'>
            <Slider {...settings}>
              {connections.map(x => (
                <div className="d-flex justify-content-left publicproduct" style={{background:"#fff"}}>                 
                    <a href=""  onClick={e => { 
                     e.preventDefault();  
                      let win = window.open(`/success-stories`);
                      win.focus(); }}
                      >
                    <Row>
                        <Col xl='12' lg='12' md='6' sm='12' xs='12'>
                        <div style={{backgroundColor:"#fff" , width:"100%", borderRadius:'13px', height:'250px'}}>
                            <div  style={{display:'inline-block', verticalAlign:'top', width:"45%", paddingLeft:'4px'}}>
                               
                                <div style={{width:"100%", display:"block"}}>
                                    <div style={{width:"20%", display:'inline-block'}}>
                                        <img
                                        alt="..."
                                        style={{maxWidth:"160%"}}
                                       // className="img-fluid shadow-lg--hover"
                                        src={x.logo ? process.env.REACT_APP_CDN_URL + x.logo : process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"}
                                        />
                                    </div>
                                    <div style={{width:"70%", display:'inline-block', paddingTop:"25px", float: "right"}}>
                                        <div style={{width:"30%", display:'inline-block'}}>
                                            
                                        <span style={{ padding: '2px 6px 2px 6px', color: '#fff',fontSize : "8px",backgroundColor : "orangered",borderRadius : '2px 6px 2px 6px'}}>{x.channelType}</span>

                                        </div>

                                        <div style={{width:"10%", display:'inline-block'}}>
                                        <CountryFlag code={x.isoCode} />
                                        </div>

                                        <div style={{ display:'inline-block', float: "right"}}>
                                        <span style={{color:'grey', fontSize:'11px'}}>{x.country}</span>
                                        </div>
                                        
                                    </div>
                                 
                                    <div style={{color:'black', width:'55%', float:'right', fontSize:'11px', marginTop:'-38px', textAlign:'left'}}> {x.companyName} </div>
                                </div>
                                <div style={{color: '#2c2929', textAlign:'justify', padding:'2px 2px 2px 2px', fontSize: '12px'}}>
                                    {x.detailDesc}
                                </div>
                            </div>

                            <div  style={{display:'inline-block', width:"10%", verticalAlign:'middle'}}>    
                                <img
                                alt="..."
                               // className="rounded-circle img-center img-fluid shadow-lg--hover"
                                src='images/successStoried.png'
                                style={{ maxWidth:"150%" , marginTop: '75px', marginLeft: '-16px'}}
                                />
                            </div>

                            <div  style={{display:'inline-block', width:"45%", verticalAlign:'top', paddingRight:'4px'}}>
                                <div style={{width:"100%", display:"block"}}>
                                    <div style={{width:"20%", display:'inline-block'}}>
                                        <img
                                        alt="..."
                                        style={{maxWidth:"100px"}}
                                       // className="img-fluid shadow-lg--hover"
                                        src={x.partnerLogo ? process.env.REACT_APP_CDN_URL + x.partnerLogo : process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"}
                                        />
                                    </div>
                                   
                                    <div style={{width:"70%", display:'inline-block', paddingTop:"25px", float: "right"}}>
                                        <div style={{width:"30%", display:'inline-block'}}>
                                            
                                        <span style={{ padding: '2px 6px 2px 6px', color: '#fff',fontSize : "8px",backgroundColor : "orangered",borderRadius : '2px 6px 2px 6px'}}>{x.partnerchannelType}</span>
                                        </div>
                                        <div style={{width:"10%", display:'inline-block'}}>
                                        <CountryFlag code={x.partnerisoCode} />
                                        </div>
                                        <div style={{ display:'inline-block', float: "right"}}>
                                        <span style={{color:'grey', fontSize:'11px'}}>{x.country}</span>
                                        </div>
                                        
                                    </div>
                                 
                                    <div style={{color:'black', width:'55%', float:'right', fontSize:'11px', marginTop:'-38px', textAlign:'left'}}> {x.partnerCompany} </div>

                                </div>
                                
                                <div style={{color: '#2c2929', textAlign:'justify', padding:'2px 2px 2px 2px', fontSize: '12px'}}>
                                    {x.partnerDetailDesc}
                                </div>
                            </div>
                        </div>
                        </Col>
                    </Row>
                    </a>
                </div>    
                ))}
            </Slider>
        </div>

    // <div className="ProductContainer" style={{ backgroundColor:buyerPage === true ? "#fff" : sliderTitle==="Latest Vendors"? "#f7f7f7" : "none", padding:"1px" }} id='dashslide'>
    //   <Slider {...settings}>
    //     {connections.map(x => (
    //        <div className="d-flex justify-content-left publicproduct">            
    //            <Col xl='3' lg='4' md='6' sm='12' xs='12' >
    //              <div id="dictnSKU00011801566" className="ListContainer" style={{ borderRadius: "10px", margin:"0",paddingTop:'3rem', backgroundColor: buyerPage===true  ? "#f7f7f7":sliderTitle==="Latest Buyers"? "#f7f7f7" : "none" }}>
    //                <a href="" onClick={e => { 
    //                   e.preventDefault();  
    //                    let win = window.open(`/channelDetailView/${x.customUrl}`);
    //                    win.focus();
    //                 }}>
    //                  <div className='list-image'>
    //                    <img
    //                      alt="..."
    //                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
    //                      src={x.logo ? process.env.REACT_APP_CDN_URL + x.logo : process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"}
    //                    />  </div>
    //                  <h3 style={{paddingTop:"2rem"}}>{x.companyName}</h3>
    //                  <p style={{paddingBottom:"1rem"}}>{x.country}</p>
    //                </a>
    //              </div>
    //            </Col>             
    //        </div>
    //      ))}
    //   </Slider>
    // </div>
  );
}; 
export default HomeEventMeetingSlider;